export const FreeProfileTabContentOne = () => {
    return (
        <>
            <div className="sector-sign-up-free-profile-list">
                <h6 className="fw-700">Join Metropolis as an employer</h6>
                <p className="fw-400">Sign up to get access to your Employer Profile and join the conversation that’s shaping your brand story.</p>
            </div>
        </>
    )
}

export const FreeProfileTabContentTwo = () => {
    return (
        <>
            <div className="sector-sign-up-free-profile-list">
                <h6 className="fw-700">Showcase your brand</h6>
                <p className="fw-400">Show prospective physicians your organization's facilities, values and perks. "Broadcast your brand/organization". Bring your brand to centre stage.</p>
            </div>
        </>
    )
}

export const FreeProfileTabContentThree = () => {
    return (
        <>
            <div className="sector-sign-up-free-profile-list">
                <h6 className="fw-700">Request and respond to reviews</h6>
                <p className="fw-400">Enjoy a rich, organized candidate flow. Get more of the right candidates for your open positions. Boost engagement across your HR team with a consistent flow of conversations with prospective physicians. Boost engagement and market insights/benchmarks.</p>
            </div>
        </>
    )
}